
import React from 'react';
import NumberStep from './NumberStep';

export default class DelayNumPageviews extends React.Component {
  render() {
    return (
      <NumberStep
        {...this.props}
        label={ 'Number of Pageviews' }
      />
    );
  }
}
